import 'react-perfect-scrollbar/dist/css/styles.css';
import React from 'react';
import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from '@mui/styles';
import GlobalStyles from 'src/components/GlobalStyles';
import 'src/mixins/chartjs';
import theme from 'src/theme';
import routes from 'src/routes';

const App = ({ keycloak }) => {
  const isLoggedIn = keycloak.authenticated;
  const routing = useRoutes(routes(isLoggedIn, keycloak));

  if (!isLoggedIn) {
    keycloak.login({ prompt: 'login', idpHint: 'google' });
  } else if (isLoggedIn) {
    return (
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        {routing}
      </ThemeProvider>
    );
  }
  return null;
};

export default App;
